import CryptoJS from 'crypto-js';
import { Base64 } from 'js-base64';

const secretKey = process.env.REACT_APP_KEY_API;

export const decrypt = (hash) => {
    try {
        if (!secretKey || secretKey.length <= 7) {
            throw new Error("Chave secreta inválida ou não definida.");
        }

        const key = secretKey.substr(7);
        const encryptedJson = JSON.parse(Base64.decode(hash));

        const decrypted = CryptoJS.AES.decrypt(
            encryptedJson.value,
            CryptoJS.enc.Base64.parse(key),
            { iv: CryptoJS.enc.Base64.parse(encryptedJson.iv) }
        );

        const plaintext = decrypted.toString(CryptoJS.enc.Utf8);

        if (!plaintext) {
            throw new Error("Falha ao descriptografar. Resultado vazio.");
        }

        return plaintext;
    } catch (err) {
        console.error("Erro ao descriptografar:", err.message);
        return null;
    }
};
